import { ICardProps } from '@/entities/Card'

export const Types = {
  fetch: 'fetch',
  error: 'error'
}

export const path = 'payment/'

export class Fetch implements FluxStandardAction<ICardProps[] | null> {
  type = path + Types.fetch
  constructor(public payload: ICardProps[] | null) {}
}

export class Error implements FluxStandardAction<unknown> {
  type = path + Types.error
  constructor(public payload: unknown) {}
}
